import { render } from "./FilterProduct.vue?vue&type=template&id=53a38e38"
import script from "./FilterProduct.vue?vue&type=script&lang=js"
export * from "./FilterProduct.vue?vue&type=script&lang=js"

import "./FilterProduct.vue?vue&type=style&index=0&id=53a38e38&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__